import { createSelector } from 'reselect'
import getCollectionIdHolidayGiftsSelect from 'modules/holiday-gifts/redux/selectors/get-collection-id'
import isHolidayGiftsUrlLocationUtil from 'utils/location/is-holiday-gifts-url'
import hasStockingStufferBadgeProductVariantSelectorUtil from 'modules/product-variant/redux/selectors/has-stocking-stuffer-badge/utils'

/**
 * @param price
 * @param isMini
 * @returns {*}
 */
const hasStockingStufferBadgeProductVariantSelector = ({ price, isMini }) => createSelector(
  getCollectionIdHolidayGiftsSelect,
  (
    collectionId
  ) => {
    return hasStockingStufferBadgeProductVariantSelectorUtil({
      price,
      collectionId,
      isMini,
      isHolidayGiftsUrl: isHolidayGiftsUrlLocationUtil()
    })
  }
)

export default hasStockingStufferBadgeProductVariantSelector
